export function showMessage(message: string): void {
  console.log(message); // TODO: Remove this or make it an actual popover notif
}
